import { render, staticRenderFns } from "./TabSaltwater.vue?vue&type=template&id=6f014de3&"
import script from "./TabSaltwater.vue?vue&type=script&lang=js&"
export * from "./TabSaltwater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports